/**
 * FamilyStory.live - Architecture JavaScript Modulaire
 * Organisation des différents modules pour une meilleure maintenabilité
 */

// Import des modules CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Import des polices Montserrat (seulement latin et latin-ext)
import '@fontsource/montserrat/latin-300.css';
import '@fontsource/montserrat/latin-400.css';
import '@fontsource/montserrat/latin-500.css';
import '@fontsource/montserrat/latin-600.css';
import '@fontsource/montserrat/latin-700.css';
// Import des accents européens
import '@fontsource/montserrat/latin-ext-300.css';
import '@fontsource/montserrat/latin-ext-400.css';
import '@fontsource/montserrat/latin-ext-500.css';
import '@fontsource/montserrat/latin-ext-600.css';
import '@fontsource/montserrat/latin-ext-700.css';


// Font Awesome
import '@fortawesome/fontawesome-free/css/all.min.css';

// Import de vos propres CSS après Bootstrap et les polices pour qu'ils aient priorité
import '../css/base.css';
import '../css/animations.css';
import '../css/layout.css';
import '../css/components.css';
import '../css/responsive.css';
import '../css/macbook-mockup.css';
import '../css/transitions.css';

// Import de Bootstrap JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { initClerkAuth } from './modules/auth.js';

// Import des modules JS
import { initCountdown } from './modules/countdown.js';
import { initRegistrationForm } from './modules/registration.js';
import { initCarouselImageLoading, initFeatureCarouselSync, adjustFeatureBlockHeight } from './modules/carousel.js';
import { initMacbookMockup } from './modules/macbook.js';
import { toggleMockupBasedOnScreenSize } from './modules/responsive.js';
import { initLazyContactForm } from './modules/lazy-contact.js';
import ScrollIndicatorManager from './modules/scroll-indicator.js';

console.log('Environnement Vite:', import.meta.env.MODE);
console.log('Clerk Key disponible:', !!import.meta.env.VITE_CLERK_PUBLISHABLE_KEY);
console.log('Clerk Key valeur:', import.meta.env.VITE_CLERK_PUBLISHABLE_KEY);

// Import conditionnel du module FAQ
if (window.location.pathname.includes('/pages/faq.html') || window.location.pathname.includes('/pages/faq')) {
  console.log('Détection de la page FAQ - chargement du module...');

  // Utiliser un import dynamique avec une gestion explicite de l'initialisation
  import('./modules/faq.js')
    .then(module => {
      console.log('Module FAQ chargé avec succès');
      // S'assurer que le DOM est complètement chargé avant d'initialiser
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        console.log('Initialisation immédiate du module FAQ');
        new module.FAQManager();
      } else {
        console.log('En attente du chargement complet du DOM pour initialiser le module FAQ');
        window.addEventListener('DOMContentLoaded', () => {
          console.log('DOM chargé - initialisation du module FAQ');
          new module.FAQManager();
        });
      }
    })
    .catch(error => console.error('Erreur lors du chargement du module FAQ:', error));
}

document.addEventListener("DOMContentLoaded", function () {
  // Initialisation de Clerk 
  initClerkAuth().catch(error => {
    console.error('Erreur d\'initialisation de l\'authentification:', error);
  });
  // Initialisation des modules communs à toutes les pages
  initLazyContactForm();

  // Vérification de la page actuelle et initialisation des modules spécifiques
  const isHomePage = !window.location.pathname.includes('/pages/');

  if (isHomePage) {
    // Modules spécifiques à la page d'accueil
    initCountdown();
    initRegistrationForm();
    initCarouselImageLoading();
    initFeatureCarouselSync();
    initMacbookMockup();
    toggleMockupBasedOnScreenSize();
    new ScrollIndicatorManager();

    // Gestion responsive pour la page d'accueil
    window.addEventListener('resize', function () {
      toggleMockupBasedOnScreenSize();
    });

    // Ajustements au chargement pour la page d'accueil
    window.addEventListener('load', adjustFeatureBlockHeight);
    setTimeout(adjustFeatureBlockHeight, 100);
    setTimeout(adjustFeatureBlockHeight, 500);
  }
});